import detectMobile from './detect-mobile';
import getComputedCss from './get-computed-css';

/* eslint-disable no-magic-numbers */
const SIZES = [
    ['mobile', 430],
    ['tablet', 800],
    ['desktop', 1600],
    ['wide', Infinity],
];

export const getScreenInfo = (mode = 'auto') => {
    const currentWidth = Math.min(
        window.innerWidth,
        window.screen.width,
        document.documentElement.clientWidth,
        document.body.offsetWidth,
        document.body.clientWidth,
    );
    const getSize = () => SIZES[SIZES.findIndex(([name, width]) => currentWidth <= width)][0];
    const hasMetaViewPortTag = () => Boolean(document.querySelector('meta[name="viewport"]'));
    return {
        width: currentWidth,
        device: getSize(),
        isMobile: setMobileInfo(mode),
        isResponsive: hasMetaViewPortTag(),
        pageFontSize: parseInt(getComputedCss(document.body, 'font-size').replace('px', '')),
    };
};

export const setMobileInfo = (mode) => {
    switch (mode) {
    case 'auto':
        return detectMobile();
    case 'mobile':
        return true;
    case 'web':
        return false;
    }
};

export default getScreenInfo;